import { ActionTypeEnum } from '../ActionTypeEnum';

const sendSMSActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.sendSMS_request_landing,
	payload,
	meta,
});

const sendSMSActionSuccess = (payload) => ({
	type: ActionTypeEnum.sendSMS_success_landing,
	payload,
});

// etma
const etmaRegistrationActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.etma_registration_request_landing,
	payload,
	meta,
});

const etmaRegistrationActionSuccess = (payload) => ({
	type: ActionTypeEnum.etma_registration_success_landing,
	payload,
});

// etma confirm
const etmaConfirmActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.etma_confirm_request_landing,
	payload,
	meta,
});

const etmaConfirmActionSuccess = (payload) => ({
	type: ActionTypeEnum.etma_confirm_success_landing,
	payload,
});

// resend
const etmaResendActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.etma_resend_request_landing,
	payload,
	meta,
});

const etmaResendActionSuccess = (payload) => ({
	type: ActionTypeEnum.etma_resend_success_landing,
	payload,
});

export {
	sendSMSActionRequest,
	sendSMSActionSuccess,
	etmaRegistrationActionRequest,
	etmaRegistrationActionSuccess,
	etmaConfirmActionRequest,
	etmaConfirmActionSuccess,
	etmaResendActionRequest,
	etmaResendActionSuccess,
};
